// import react and gatsby libs
import React from 'react'
import { Link } from 'gatsby'

// import css libs
import styled from 'styled-components'
import media from 'styled-media-query'

// import assets
import LogoImg from '../assets/logo.png'


// styled Navigation element
const Navigation = styled.nav`

  background: #222;
  overflow: hidden;
  width: 100vw;

  ${media.greaterThan("small")`
    /* screen width is greater than 450px (small) */
    position: fixed;
    width: 30vw;
    height: 100vh;
  `}

  ${media.greaterThan("medium")`
    /* screen width is greater than 768px (large) */
    width: 20vw;
  `}
`

// Logo vars
const logoHeight = '6rem'

// styled Logo element
const Logo = styled.div`

  width: auto;
  margin: 0 auto;
  overflow: hidden;

  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: auto;
    height: ${logoHeight};
    box-sizing: border-box;
    padding: 1rem;
    float: left;
  }

  h1 {
    float: left;
    font-weight: 100;
    line-height: ${logoHeight};
    font-size: 1.75rem;
    margin: 0;

    a {
      text-decoration: none;
      color: #222;
    }
  }

  ${media.greaterThan("small")`
    /* screen width is greater than 450px (small) */
    display: block;
    margin: 0;
    width: 100%;

    img {
      width: 100%;
      padding: 2rem;
      height: auto;
    }
    h1 {
      display: none;
    }
  `}

  ${media.greaterThan("medium")`
    /* screen width is greater than 768px (large) */

    img {
      padding: 3rem 3rem 0;
    }

  `}

`

// styled List element
const List = styled.ul`

  list-style: none;
  font-size: 1.25rem;
  line-height: 2rem;
  margin: 0;
  padding: 1rem 0;
  width: 100%;
  text-align: center;
  background: #eee;

  li {

    a {
      text-decoration: none;
      color: #fff;
      transition: all 100ms ease-out;

      &:hover {
        color: #8cd2e3;
      }
    }
  }

  ${media.greaterThan("small")`
    /* screen width is greater than 450px (small) */
    background: none;
    padding: 2rem 0;

    li {
      line-height: 2rem;

      a {

        font-size: 1.25rem;
      }
    }
  `}

  ${media.greaterThan("medium")`
    /* screen width is greater than 768px (large) */

  `}

`

// export Navigation component
export default () => (
  <Navigation>
    <Logo>
      <Link to="/">
        <img src={LogoImg} alt="How2charist" />
      </Link>
      <h1>
        <Link to="/">How2charist</Link>
      </h1>
    </Logo>
    <List>
      <li>
        <Link to="/">Home</Link>
      </li>
      <li>
        <Link to="/about">About How2charist</Link>
      </li>
      <li>
        <Link to="/partners">Partner Backers</Link>
      </li>
      <li>
        <Link to="/contributors">Contributors</Link>
      </li>
      <li>
        <Link to="/contact">Contact</Link>
      </li>
    </List>
  </Navigation>
)
